import _find from 'lodash/find'; // eslint-disable-line
import { ActionTypes } from '../actions/cardCatalogActions';

const initialState = {
  busy: false,
  initial: true,
  filters: {
    // query: null,
    limit: 12,
    offset: 0,
    active_only: false,
    color: null,
    lead_card_type: null,
    has_foil: null,
    has_custom_photo: null
  },
  suites: {
    list: [],
    byUUID: {},
    orderedUUIDs: [],
    count: 0,
  },
  detailSuite: {
    uuid: null,
    name: null,
    description: null,
    cards: [],
    // leadCard: {
    //   id: null,
    //   name: null,
    //   option_groups: [],
    // },
    leadCard: null,
    // variationOptions: {
    //   color: null,
    //   'paper-type': 'smooth',
    //   silhouette: 'square',
    //   'reverse-printing': null
    // }
    variationOptions: {},
  },
  themeGroupsForCards: {},
  initialVariationColor: null,
};

const cardCatalogReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_SEARCH_CARD_SUITES: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_SEARCH_CARD_SUITES: {
      const { cardSuites } = action.payload;
      const { byUUID, orderedUUIDs } = cardSuites.suites.reduce((result, suite) => {
        // result[suite.uuid] = { ...suite, index: idx }; // eslint-disable-line
        if (!result.byUUID[suite.uuid]) {
          result.orderedUUIDs.push(suite.uuid);
        }
        result.byUUID[suite.uuid] = suite; // eslint-disable-line
        return result;
      }, { byUUID: { ...state.suites.byUUID }, orderedUUIDs: [...state.suites.orderedUUIDs] });
      // const orderedCardSuiteUUIDs = cardSuites.suites.map(suite => suite.uuid);
      // const nextOrderedCardSuiteUUIDs = [...state.suites.orderedUUIDs, ...orderedCardSuiteUUIDs];

      return {
        ...state,
        initial: false,
        busy: false,
        suites: {
          // list: [...state.suites.list, ...cardSuites.suites],
          // byUUID: nextCardSuitesByUUID,
          // orderedUUIDs: [...state.suites.orderedUUIDs, ...orderedCardSuiteUUIDs],
          // count: nextOrderedCardSuiteUUIDs.length
          byUUID,
          orderedUUIDs,
          count: orderedUUIDs.length
        },
        filters: {
          ...state.filters,
          limit: cardSuites.limit,
          offset: cardSuites.offset,
          color: cardSuites.color,
          lead_card_type: cardSuites.lead_card_type
        }
      };
    }
    case ActionTypes.RECEIVE_CARD_SUITE: {
      const { cardSuite } = action.payload;
      const { uuid, name, description, items } = cardSuite;
      const leadItem = _find(items, { lead: true });
      const leadCard = leadItem.card;
      const optionGroupsByKey = leadCard.option_groups.reduce((result, optionGroup) => {
        const { key, ...rest } = optionGroup;
        result.orderedKeys.push(key);
        result[key] = rest; // eslint-disable-line
        return result;
      }, { orderedKeys: [] });
      const variationsOptionValues = leadCard.variations.map(variation => ({ uuid: variation.uuid, ...variation.option_values }));

      const defaultVariationOptions = {
        silhouette: 'square',
        'paper-type': 'smooth',
        'reverse-printing': 'true',
      };
      if (state.initialVariationColor) {
        defaultVariationOptions.color = state.initialVariationColor;
      }
      const variationOptions = {};
      leadCard.option_groups.forEach((optionGroup) => {
        let defaultOption;
        if (optionGroup.options.length === 1) {
          defaultOption = optionGroup.options[0];
        } else if (defaultVariationOptions[optionGroup.key]) {
          defaultOption = _find(optionGroup.options, { value: defaultVariationOptions[optionGroup.key] }) || optionGroup.options[0];
        } else {
          defaultOption = optionGroup.options && optionGroup.options[0];
        }
        variationOptions[optionGroup.key] = defaultOption.value;
      });
      return {
        ...state,
        detailSuite: {
          uuid,
          name,
          description,
          cards: items,
          leadCard: {
            ...leadCard,
            optionGroupsByKey,
            variationsOptionValues,
          },
          variationOptions
        }
      };
    }
    case ActionTypes.UPDATE_VARIATION_OPTIONS: {
      const { key, value } = action.payload;
      console.log('UPDATE VARIATION OPTIONS: ', key, value);
      return {
        ...state,
        detailSuite: {
          ...state.detailSuite,
          variationOptions: {
            ...state.detailSuite.variationOptions,
            [key]: value
          }
        }
      };
    }
    case ActionTypes.RECEIVE_CARD: {
      const { card } = action.payload;
      console.log('RECEIVE CARD: ', card);
      return state;
    }
    case ActionTypes.UPDATE_SEARCH_FILTERS: {
      const { key, value } = action.payload;
      if (key === 'lead_card_type') {
        // console.log('UPDATE_SEARCH_FILTERS: ', key, value);
        return {
          ...state,
          initial: true,
          filters: {
            ...initialState.filters,
            lead_card_type: value
          },
          suites: initialState.suites
        };
      }
      return {
        ...state,
        initial: true,
        filters: {
          ...state.filters,
          limit: initialState.filters.limit,
          offset: initialState.filters.offset,
          [key]: value
        },
        suites: initialState.suites,
      };
    }
    case ActionTypes.RESET_SEARCH_FILTERS: {
      return {
        ...state,
        initial: true,
        filters: {
          ...initialState.filters,
          lead_card_type: state.filters.lead_card_type
        },
        suites: initialState.suites
      };
    }
    case ActionTypes.SET_INITIAL_VARIATION_COLOR: {
      const { color } = action.payload;
      return {
        ...state,
        initialVariationColor: color
      };
    }
    case ActionTypes.REQUEST_THEME_GROUPS_FOR_CARD: {
      return state;
    }
    case ActionTypes.RECEIVE_THEME_GROUPS_FOR_CARD: {
      const { cardUUID, themeGroups } = action.payload;
      return {
        ...state,
        themeGroupsForCards: {
          ...state.themeGroupsForCards,
          [cardUUID]: themeGroups
        }
      };
    }
    default: {
      return state;
    }
  }
};

export default cardCatalogReducer;



// WEBPACK FOOTER //
// ./src/cards/reducers/cardCatalog.js